import { combineReducers } from '@reduxjs/toolkit'

import {
  DOMAINS_CACHE_REDUCER_NAME,
  DOMAIN_DEALERS_REDUCER_NAME,
  DOMAIN_EXPORT_REDUCER_NAME,
  DOMAIN_JOBS_WITH_HOME_REDUCER_NAME,
  DOMAIN_JOBS_WITH_HOME_COUNT_REDUCER_NAME,
  MIST_ORGANIZATION_REDUCER_NAME,
  DOMAIN_PENDING_JOBS_REDUCER_NAME,
  SELECTED_NAV_DOMAIN_REDUCER_NAME,
  SELECTED_NAV_TOP_DOMAIN_REDUCER_NAME,
} from './consts'
import { DOMAIN_SUB_DOMAIN_FETCH_DATA } from 'components/DomainBreadcrumbs/consts'

import {
  domainsCacheReducer,
  domainJobsWithHomeReducer,
  selectedNavDomainReducer,
  domainPendingJobsReducer,
  selectedNavTopDomainReducer,
  domainDealersReducer,
  domainExportReducer,
  domainJobsWithHomeCountReducer,
} from './slice'
import { domainSubDomainsFetchSlice } from 'components/DomainBreadcrumbs/slice'
import mistOrganizationReducer from './../networkAi/reducer'

export default combineReducers({
  [DOMAINS_CACHE_REDUCER_NAME]: domainsCacheReducer,
  [DOMAIN_JOBS_WITH_HOME_REDUCER_NAME]: domainJobsWithHomeReducer,
  [DOMAIN_JOBS_WITH_HOME_COUNT_REDUCER_NAME]: domainJobsWithHomeCountReducer,
  [DOMAIN_PENDING_JOBS_REDUCER_NAME]: domainPendingJobsReducer,
  [SELECTED_NAV_DOMAIN_REDUCER_NAME]: selectedNavDomainReducer,
  [SELECTED_NAV_TOP_DOMAIN_REDUCER_NAME]: selectedNavTopDomainReducer,
  [DOMAIN_SUB_DOMAIN_FETCH_DATA]: domainSubDomainsFetchSlice.reducer,
  [DOMAIN_DEALERS_REDUCER_NAME]: domainDealersReducer,
  [DOMAIN_EXPORT_REDUCER_NAME]: domainExportReducer,
  [MIST_ORGANIZATION_REDUCER_NAME]: mistOrganizationReducer,
})
